import React from "react";
import { NomenclaturesCategoriesPage } from "./NomenclaturesCategoriesPage";
import { useNomenclaturesCategories } from "./useNomenclaturesCategories";

function NomenclaturesCategories() {
  return <NomenclaturesCategoriesPage {...useNomenclaturesCategories()} />;
}

export default NomenclaturesCategories;
